import { URLList } from "@/data/url_list";
import { FetchApiClientMethod } from "@sadtx/fetch-api-client";
import { errorConverter, SATError, SATResult } from "@sadtx/sat-error";
import { NoticeDto } from "../dto/notice/notice-dto";
import { AddNoticePayload } from "../payload/notice/add-notice-payload";
import { GetNoticeIdPayload } from "../payload/notice/get-notice-id-payload";
import { UpdateNoticePayload } from "../payload/notice/update-notice-payload";

export class NoticeSource {
  constructor(private readonly client: FetchApiClientMethod) {}

  async getNoticesList(): Promise<SATResult<NoticeDto[], SATError>> {
    try {
      const params = "/?isOnlyActive=true";
      const response = await this.client.get(URLList.NOTICE.GET_NOTICE_LIST + params);
      console.log("[NoticeSource] :: getNoticesList :: 공지사항 목록 조회 성공", response.data);
      // API 응답에서 notices 배열을 추출
      const notices = response.data.notices || [];
      return SATResult.success(notices);
    } catch (error: unknown) {
      console.log("[NoticeSource] :: getNoticesList :: 공지사항 목록 조회 실패", error);
      const satError = errorConverter.convertError(error);
      console.log("[NoticeSource] :: getNoticesList | ", satError);
      return SATResult.failure(satError);
    }
  }

  async getNoticeDetail(
    payload: GetNoticeIdPayload
  ): Promise<SATResult<NoticeDto, SATError>> {
    try {
      const url = `${URLList.NOTICE.GET_NOTICE_DETAIL}/${payload.id}`;
      console.log("[NoticeSource] :: getNoticeDetail :: 요청 URL", url);
      console.log("[NoticeSource] :: getNoticeDetail :: payload.id", payload.id);
      const response = await this.client.get(url);
      console.log("[NoticeSource] :: getNoticeDetail :: 공지사항 상세 조회 성공", response.data);
      return SATResult.success(response.data);
    } catch (error: unknown) {
      console.log("[NoticeSource] :: getNoticeDetail :: 공지사항 상세 조회 실패", error);
      const satError = errorConverter.convertError(error);
      console.log("[NoticeSource] :: getNoticeDetail | ", satError);
      return SATResult.failure(satError);
    }
  }

  async addNotice(payload: AddNoticePayload): Promise<SATResult<void, SATError>> {
    try {
      await this.client.post(URLList.NOTICE.ADD_NOTICE, payload);
      console.log("[NoticeSource] :: addNotice :: 공지사항 추가 성공");
      return SATResult.success(void 0);
    } catch (error: unknown) {
      console.log("[NoticeSource] :: addNotice :: 공지사항 추가 실패", error);
      const satError = errorConverter.convertError(error);
      console.log("[NoticeSource] :: addNotice | ", satError);
      return SATResult.failure(satError);
    }
  }

  async updateNotice(
    noticeUuid: string,
    payload: UpdateNoticePayload
  ): Promise<SATResult<void, SATError>> {
    try {
      const url = `${URLList.NOTICE.UPADTE_NOTICE}/${noticeUuid}`;
      await this.client.put(url, payload.notice);
      console.log("[NoticeSource] :: updateNotice :: 공지사항 수정 성공");
      return SATResult.success(void 0);
    } catch (error: unknown) {
      console.log("[NoticeSource] :: updateNotice :: 공지사항 수정 실패", error);
      const satError = errorConverter.convertError(error);
      console.log("[NoticeSource] :: updateNotice | ", satError);
      return SATResult.failure(satError);
    }
  }

  async updateNoticeByUuid(
    noticeUuid: string,
    payload: UpdateNoticePayload
  ): Promise<SATResult<void, SATError>> {
    try {
      const url = `${URLList.NOTICE.UPADTE_NOTICE}/${noticeUuid}`;
      await this.client.put(url, payload.notice);
      console.log("[NoticeSource] :: updateNoticeByUuid :: 공지사항 수정 성공");
      return SATResult.success(void 0);
    } catch (error: unknown) {
      console.error("[NoticeSource] :: updateNoticeByUuid :: 공지사항 수정 실패", error);
      const satError = errorConverter.convertError(error);
      console.error("[NoticeSource] :: updateNoticeByUuid :: 변환된 에러", satError);
      return SATResult.failure(satError);
    }
  }
}
